interface TrackingConsentPayload {
  region?: string; // e.g. EU, US
  domain: string; // e.g. .petsafe.com
}

declare global {
  interface Window {
    OptanonActiveGroups?: string[];
  }
}

export function setTrackingConsentCookie({
  region,
  domain,
}: Readonly<TrackingConsentPayload>) {
  // Map OneTrust group IDs to consent values
  const analyticsConsent = window.OptanonActiveGroups?.includes('C0002')
    ? 1
    : 0;
  const functionalConsent = window.OptanonActiveGroups?.includes('C0003')
    ? 1
    : 0;
  const adsConsent = window.OptanonActiveGroups?.includes('C0004') ? 1 : 0;

  // CMP string encoding reflects actual user consent
  const cmp = {
    a: analyticsConsent.toString(), // analytics
    m: adsConsent.toString(), // marketing
    p: functionalConsent.toString(), // personalization/functional
    s: '1', // strictly necessary always allowed
  };

  // Purposes boolean mirrors CMP in developer-friendly format
  const purposes = {
    a: analyticsConsent === 1,
    m: adsConsent === 1,
    p: functionalConsent === 1,
    t: true, // strictly necessary always true
  };

  // saleOfDataRegion: true if region is US and adsConsent allows sale of data (example)
  const saleOfDataRegion = region === 'US' && adsConsent === 1;

  const payload = {
    con: { CMP: cmp },
    v: '2.1',
    region: region || 'US',
    reg: '',
    cus: {
      'onetrust.groups': `C0001:1,C0002:${analyticsConsent},C0003:${functionalConsent},C0004:${adsConsent}`,
      'onetrust.datestamp': new Date().toISOString(),
    },
    purposes,
    display_banner: false,
    sale_of_data_region: saleOfDataRegion,
    consent_id: crypto.randomUUID(),
  };

  // Set cookie for all subdomains
  document.cookie = `_tracking_consent=${encodeURIComponent(
    JSON.stringify(payload)
  )}; Path=/; Domain=${domain}; SameSite=Lax; Secure`;

  console.log('Set _tracking_consent cookie:', payload);
}
